export const config = {
  logoSrc: "/Logosmall.png",
  siteName: "Travel Website",
  primaryColor: "yellow-400",
  backendServer: "https://travel-website-i88h.onrender.com",
  socialLinks: {
    linkedin: "https://linkedin.com/company/",
    facebook: "https://facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://instagram.com/",
  },
  companyInfo: {
    name: "Travel Website Ltd",
    registration: "Incorporated in England: 02885223",
    copyright: "© 2025 All rights reserved",
  },
};
